import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "./locales/en.json";
import translationAr from "./locales/ar.json";
import languageDetector from "i18next-browser-languagedetector";
import { IS_LANDING } from "../constants/appConfig";

const resources = {
  en: {
    translation: translationEn,
  },
  ar: {
    translation: translationAr,
  },
};

const i18nInstance = i18n.use(initReactI18next);

if (!IS_LANDING) {
  i18nInstance.use(languageDetector);
}

const initOptions = {
  resources,
  fallbackLng: IS_LANDING ? "ar" : "en",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
};

if (IS_LANDING) {
  initOptions.lng = "ar";
} else {
  initOptions.detection = {
    order: ["localStorage", "navigator", "htmlTag"],
    caches: ["localStorage"],
    lookupLocalStorage: "i18nextLng",
  };
}

i18nInstance.init(initOptions);

export default i18n;
